import * as Diff from 'diff';
import * as Diff2Html from 'diff2html';
import 'diff2html/bundles/css/diff2html.min.css';

// DOM要素の取得
const textA = document.getElementById('textA');
const textB = document.getElementById('textB');
const diffOutput = document.getElementById('diffOutput');
const compareBtn = document.getElementById('compareBtn');
const clearBtn = document.getElementById('clearBtn');

// Unified Diff形式の文字列を生成
function createUnifiedDiff(oldText, newText, oldFileName = 'Text A', newFileName = 'Text B') {
    // jsdiffライブラリを使用してパッチを生成
    const diff = Diff.createPatch(
        'comparison',
        oldText,
        newText,
        oldFileName,
        newFileName
    );
    return diff;
}

// diff2htmlを使って差分を表示
function displayDiff(oldText, newText) {
    if (!oldText && !newText) {
        diffOutput.innerHTML = '<div class="empty-state">テキストを入力して「差分を表示」ボタンをクリックしてください</div>';
        return;
    }

    // Unified Diff形式に変換
    const unifiedDiff = createUnifiedDiff(oldText, newText);

    // diff2htmlでHTMLに変換
    const diffHtml = Diff2Html.html(unifiedDiff, {
        drawFileList: false,
        matching: 'lines',
        outputFormat: 'side-by-side',
        renderNothingWhenEmpty: false,
    });

    diffOutput.innerHTML = diffHtml;
}

// 比較ボタンのイベントリスナー
compareBtn.addEventListener('click', () => {
    const textAValue = textA.value;
    const textBValue = textB.value;

    if (!textAValue && !textBValue) {
        alert('テキストを入力してください');
        return;
    }

    displayDiff(textAValue, textBValue);
});

// クリアボタンのイベントリスナー
clearBtn.addEventListener('click', () => {
    textA.value = '';
    textB.value = '';
    diffOutput.innerHTML = '<div class="empty-state">テキストを入力して「差分を表示」ボタンをクリックしてください</div>';
});

// 初期表示
displayDiff('', '');

// Export for demo.html
window.compareBtn = compareBtn;
